document.addEventListener('DOMContentLoaded', function () {
    // Both desktop and mobile search forms
    const desktopSearchForm = document.querySelector('.header-search-form'); // For desktop
    const mobileSearchForm = document.querySelector('.mobile-search-form');  // For mobile (adjust class as necessary)

    const searchInputs = [];

    // Check if the desktop search form exists and add its input
    if (desktopSearchForm) {
        searchInputs.push(desktopSearchForm.querySelector('input[name="q"]'));
    }

    // Check if the mobile search form exists and add its input
    if (mobileSearchForm) {
        searchInputs.push(mobileSearchForm.querySelector('input[name="q"]'));
    }

    // Outer container to control visibility
    const outerContainer = document.createElement('div');
    outerContainer.classList.add('search-results-outer-container');
    let activeForm;  // To track the active search form being used

    // Inner container for the two-column layout
    const innerContainer = document.createElement('div');
    innerContainer.classList.add('search-results-inner-container');
    outerContainer.appendChild(innerContainer);

    // Create left and right columns
    const leftColumn = document.createElement('div');
    leftColumn.classList.add('search-results-left');
    const rightColumn = document.createElement('div');
    rightColumn.classList.add('search-results-right');

    // Append columns to the inner container
    innerContainer.appendChild(leftColumn);
    innerContainer.appendChild(rightColumn);

    let debounceTimeout;

    // Function to fetch search results using the Predictive Search API
    function fetchResults(query) {
        const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each`;

        fetch(searchUrl)
            .then(response => response.json())
            .then(data => {
                const products = data.resources.results.products || [];
                const collections = data.resources.results.collections || [];
                const suggestions = data.resources.results.queries || [];

                // Limit results to 6 products, 2 suggestions, and 2 collections
                const productsLimit = 6;
                const suggestionsLimit = 2;
                const collectionsLimit = 2;

                // Display products in the right column
                displayResults(products.slice(0, productsLimit), query, products.length);

                // Display query suggestions and collections in the left column
                displayLeftColumn(suggestions.slice(0, suggestionsLimit), collections.slice(0, collectionsLimit));

                // Attach the outerContainer to the active form
                if (activeForm && !activeForm.contains(outerContainer)) {
                    activeForm.appendChild(outerContainer);
                }

            })
            .catch(error => {
                console.error('Error fetching search results:', error);
            });
    }

    // Function to display search results in the right column
    function displayResults(products, query, totalProducts) {
        rightColumn.innerHTML = ''; // Clear previous results

        if (products.length === 0) {
            rightColumn.innerHTML = '<p>No products found.</p>';
            return;
        }

        const resultsList = document.createElement('ul');
        resultsList.classList.add('results-grid'); // Add a class for styling as a grid

        products.forEach(product => {
            const resultItem = document.createElement('li');
            resultItem.classList.add('result-item'); // Add a class for styling the list item

            resultItem.addEventListener('click', function () {
                window.location.href = product.url;
            });

            const thumbnail = document.createElement('img');
            thumbnail.src = product.image ? product.image : '/path/to/placeholder.jpg';
            thumbnail.alt = product.title;
            thumbnail.classList.add('product-thumbnail');

            const productInfo = document.createElement('div');
            productInfo.classList.add('product-info');

            const productTitle = document.createElement('p');
            productTitle.textContent = product.title;
            productTitle.classList.add('product-title');

            const productPrice = document.createElement('p');
            productPrice.textContent = product.price ? `£${product.price}` : 'Price unavailable';
            productPrice.classList.add('product-price');

            productInfo.appendChild(productTitle);
            productInfo.appendChild(productPrice);

            resultItem.appendChild(thumbnail);
            resultItem.appendChild(productInfo);

            resultsList.appendChild(resultItem);
        });

        rightColumn.appendChild(resultsList);

        const seeAllDiv = document.createElement('div');
        seeAllDiv.classList.add('see-all-products');
        const seeAllLink = document.createElement('a');
        seeAllLink.href = `/search?q=${encodeURIComponent(query)}&type=product`;
        seeAllLink.textContent = `See all products matching "${query}"`;
        seeAllDiv.appendChild(seeAllLink);

        rightColumn.appendChild(seeAllDiv);
        outerContainer.style.display = 'block';
    }

    // Function to display query suggestions and collections in the left column
    function displayLeftColumn(suggestions, collections) {
        leftColumn.innerHTML = ''; // Clear previous results

        const suggestionsHeading = document.createElement('h3');
        suggestionsHeading.textContent = 'Suggestions';
        leftColumn.appendChild(suggestionsHeading);

        if (suggestions.length === 0) {
            const noSuggestions = document.createElement('p');
            noSuggestions.textContent = 'No suggestions found.';
            leftColumn.appendChild(noSuggestions);
        } else {
            const suggestionsList = document.createElement('ul');
            suggestions.forEach(suggestion => {
                const suggestionItem = document.createElement('li');
                const suggestionLink = document.createElement('a');
                suggestionLink.href = suggestion.url;
                suggestionLink.textContent = suggestion.text;

                suggestionItem.appendChild(suggestionLink);
                suggestionsList.appendChild(suggestionItem);
            });
            leftColumn.appendChild(suggestionsList);
        }

        const collectionsHeading = document.createElement('h3');
        collectionsHeading.textContent = 'Collections';
        leftColumn.appendChild(collectionsHeading);

        if (collections.length === 0) {
            const noCollections = document.createElement('p');
            noCollections.textContent = 'No matching collections found.';
            leftColumn.appendChild(noCollections);
        } else {
            const collectionsList = document.createElement('ul');
            collections.forEach(collection => {
                const collectionItem = document.createElement('li');
                const collectionLink = document.createElement('a');
                collectionLink.href = collection.url;
                collectionLink.textContent = collection.title;

                collectionItem.appendChild(collectionLink);
                collectionsList.appendChild(collectionItem);
            });

            leftColumn.appendChild(collectionsList);
        }
    }

    // Hide the outer container initially
    outerContainer.style.display = 'none';

    // Add event listener to all search inputs
    searchInputs.forEach(input => {
        if (input) { // Ensure input is not null
            input.addEventListener('input', function () {
                const query = this.value.trim();

                if (query.length < 3) {
                    outerContainer.style.display = 'none'; // Hide results if input is too short
                    return;
                }

                // Determine which form is active
                activeForm = input.closest('form');

                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(function () {
                    fetchResults(query);
                }, 300); // Debounce to limit API calls
            });
        }
    });
});
